import api from "./client";

// Fetch all ASN for Manual Dropdown
export const getASNList = () =>
  api.get(`/api/putaway/asn-list`);

// Fetch SKU List based on ASN selection
export const getSKUsByASN = (asn) =>
  api.get(`/api/putaway/skus`, {
    params: { asn },
  });

// Fetch Shipper Info + Received + Binned Pieces
export const getASNDetails = (asn, sku) =>
  api.get(`/api/putaway/asn-details`, {
    params: { asn, sku },
  });

// Fetch Location IDs
export const getLocations = () =>
  api.get(`/api/putaway/locations`);

// Submit Put-Away Task
export const submitPutAway = (
  asn,
  sku,
  locationId,
  pieces,
  shipperId,
  shipperName,
  userId
) =>
  api.post(`/api/putaway/submit`, {
    asn,
    sku,
    locationId,
    pieces,
    shipperId,
    shipperName,
    userId,
  });
